// ============================================
// TOUR - Botón flotante para relanzar el tour
// ============================================
// Reutilizable por cualquier módulo. Fijo abajo a la derecha (patrón FAB
// estándar, alcanzable con el pulgar en mobile) — a propósito NO arriba a la
// derecha, donde ya viven los toasts (`fixed top-4 right-4` en Toast.tsx),
// para no competir visualmente con ellos.
// `bottom-24` (no `bottom-6`): el widget de soporte de terceros vive fijo en
// la esquina inferior derecha con un z-index más alto que este botón: a
// `bottom-6` quedaba casi tapado por completo. Se deja este espacio libre
// para que ambos convivan sin solaparse.

import type { IconType } from 'react-icons';
import { MdLightbulbOutline } from 'react-icons/md';

interface TourFabProps {
  onClick: () => void;
  label?: string;
  icon?: IconType;
}

export const TourFab = ({ onClick, label = 'Ver tour', icon: Icon = MdLightbulbOutline }: TourFabProps) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={label}
    title={label}
    className="fixed bottom-20 right-4 z-40 flex h-11 w-11 items-center justify-center rounded-full shadow-lg transition-transform hover:scale-105 active:scale-95 md:bottom-24 md:right-6 md:h-14 md:w-14"
    style={{ backgroundColor: '#11194F' }}
  >
    <Icon className="text-lg text-white md:text-2xl" />
  </button>
);
